import { lazyGetRoomFreeBusy } from 'owa-room-selection';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

/**
 * Calls getRoomAvailability API for the rooms in the get calendar event, if the event is a recurrence.
 * getRoomAvailability will return results from the cache if we already have them.
 * This is only for logging for experiment. We fetch the availabilities for all rooms using GetRoomAvailability,
 * even when the flight 'cal-mf-availabilityForRecurrence' is off. To compare this availabilities between treatment and control.
 * TODO: Remove this when experiment is over (https://exp.microsoft.com/Rollout?id=f3d8a340-9076-46ee-8db1-d8e17e131b38)
 */
export default function fetchRecurrentEventResourcesAvailability(event: CalendarEvent) {
    if (event?.Recurrence && event.Resources && event.Resources.length > 0) {
        lazyGetRoomFreeBusy.import().then(getRoomFreeBusy => {
            const calendarEventTime = {
                Start: event.Start,
                End: event.End,
                IsAllDayEvent: event.IsAllDayEvent,
                Recurrence: event.Recurrence,
                RequiredAttendees: event.RequiredAttendees,
                OptionalAttendees: event.OptionalAttendees,
            };

            event.Resources.forEach(room => {
                getRoomFreeBusy(
                    room.Mailbox.EmailAddress,
                    null /* cacheManager */,
                    calendarEventTime,
                    null /* bookingType */,
                    null /* filter */,
                    true /* useGetRoomAvailabilityForLogging */
                );
            });
        });
    }
}
